"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.plCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var plCountry = exports.plCountry = function plCountry(t) {
  return {
    id: 'PL',
    name: t('Poland'),
    flag: '🇵🇱',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[0-9]{2}-[0-9]{3}$/;
      return regex.test(zipcode);
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 00-001 or 80-001',
    phonePrefix: '48',
    phoneLength: 9,
    pricingVersion: 14,
    timezone: 'Europe/Warsaw',
    currency: 'EUR'
  };
};